import axios from 'axios';
import { Cookies } from 'react-cookie';
import { atom, selector } from 'recoil';
import { URL_FOUNDATION } from '../config/keys';

// -----------------------[ ATOM ]----------------------- //
const ACompaniesAtom = atom<Record<number, string>>({
	key: 'ACompaniesAtom', // UNIQUE ID
	default: getClientCompanies().then(a => a.reduce((acc, [id, name]) => {
		acc[id] = name;
		return acc;
	}, {} as Record<number, string>))
});

export const ACompanies = selector<Record<number, string>>({
	key: 'ACompanies',
	get: ({ get }) => get(ACompaniesAtom),
	set: ({ set }, newValue) => set(ACompaniesAtom, newValue)
});

// -----------------------[ API ]------------------------ //
const cookies = new Cookies();
const token: string | null = cookies.get('id_token') || null;

axios.defaults.headers.common.Authorization = `${token ?? ''}`;

export async function getClientCompanies(): Promise<[number, string][]> {
	try {
		return await axios({
			method: 'get',
			url: `${URL_FOUNDATION}/api/v2/client-companies/atom`
		}).then(res => res.data);
	} catch (e) {
		console.error(e);
		return [];
	}
}
